import { labelMappingCtx } from './context';

export const LabelMappingCtxProvider = labelMappingCtx.Provider;
